import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "pencil",
  "use": "pencil-usage",
  "viewBox": "0 0 640 640",
  "content": "<symbol viewBox=\"0 0 640 640\" id=\"pencil\"><path d=\"M470.08 85.152C409.472 41.024 366.336 41.984 349.952 44.64c-4.608.736-8.48 3.392-11.2 7.136L118.496 355.68a78.302 78.302 0 0 0-14.784 41.824L94.24 577.472c-.672 12.96 12.224 22.336 24.32 17.696l168.192-64.32c14.176-5.44 26.496-14.88 35.392-27.168l220.16-303.808c2.848-3.936 4-8.736 3.2-13.536-2.688-16.832-15.584-57.664-75.424-101.184zM287.264 494.88l-65.376 25.248a6.08 6.08 0 0 1-7.072-1.984c-8.416-10.72-18.432-21.344-34.4-32.96-15.968-11.584-29.152-17.856-41.92-22.592-2.56-.96-4.192-3.392-4.032-6.144l3.904-69.952 17.568-24.16s39.328-5.408 90.656 31.936c51.264 37.312 58.272 76.416 58.272 76.416l-17.6 24.192z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pencil.svg
// module id = QtaU
// module chunks = 1